import CloseIcon from "@mui/icons-material/Close";
import { Button, Modal, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import {
  DocumentsTableDetail,
  QuestionsTableDetail,
  TagsTableDetail,
} from "components";
import { dashDelete, dateConvertString, getYearsFromBirth } from "helpers";
import { useEffect, useState } from "react";
import { BsCol, BsContainer, BsRow } from "../../layouts/components";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    // backgroundColor: theme.palette.background.paper,
    // // border: '2px solid #000',
    // borderRadius: theme.shape.borderRadius,
    // boxShadow: theme.shadows[3],
    // padding: theme.spacing(1, 3, 3),
    // width: '75%',
    // minHeight: '60vh',
    // maxHeight: '90vh',
    // flexDirection: 'column',
    // display: 'flex',
    // justifyContent: 'flex-start',
    backgroundColor: theme.palette.background.paper,
    // border: '2px solid #000',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    padding: theme.spacing(1, 3, 7),
    width: "80%",
    height: "65vh",
    margin: "auto",
  },
  scrollAreaModalStyle: {
    overflow: "auto",
    flexGrow: 1,
  },
  divider: {
    background: theme.palette.grey[400],
    marginTop: 10,
  },
  root: {
    color: theme.palette.tertiary.main,
    fontWeight: 500,
  },
  tableStyle: {
    "& th": {
      fontSize: 18,
      // lineHeight: 2,
    },
    "& tr td": {
      fontSize: 15,
      // paddingTop: 5,
      // paddingBottom: 8,
    },
  },
  tdListStyle: {
    listStyle: "inside",
    "& li": {
      marginBottom: 10,
    },
  },
  labelTd: {
    fontWeight: 700,
  },
}));

const ModalWidgetDetailTable = (props) => {
  const { openDetail, detailModal, moduleName, size, closeFunc } = props;
  const [openStateDetail, setOpenStateDetail] = useState(openDetail);
  // console.log(detailModal, 'carga modal');

  const classes = useStyles();
  const theme = useTheme();

  const handleClose = () => {
    closeFunc(false);
  };

  useEffect(() => {
    setOpenStateDetail(openDetail);
  }, [openDetail]);

  const handleRowTable = (row) => {
    const detail = [];
    for (let fieldName in row) {
      switch (fieldName) {
        case "lastName":
          detail.push({
            label: "Apellidos",
            value: row[fieldName],
            order: 1,
          });
          break;
        case "phone":
          detail.push({
            label: "Teléfono",
            value: row[fieldName],
            order: 2,
          });
          break;
        case "rut":
          detail.push({
            label: "Rut",
            value: row[fieldName],
            order: 3,
          });
          break;
        case "tote":
          detail.push({
            label: "Valores Tote",
            value: row[fieldName],
            order: 6,
            map: true,
          });
          break;
        // case 'subcontrators':
        //   detail.push({
        //     label: 'Subcontratista',
        //     value: row[fieldName].name,
        //     order: 4
        //   });
        //   break;
        case "email":
          detail.push({
            label: "Email",
            value: row[fieldName],
            order: 5,
          });
          break;
        case "codeSession":
          detail.push({
            label: "Código",
            value: row[fieldName],
            order: 6,
          });
          break;
        case "name":
          detail.push({
            label: "Nombre",
            value: row[fieldName],
            order: 7,
          });
          break;
        case "username":
          detail.push({
            label: "Nombre Usuario",
            value: row[fieldName],
            order: 3,
          });
          break;

        case "date":
          detail.push({
            label: "Fecha",
            value: row[fieldName],
            order: 11,
          });
          break;

        case "orchard":
          detail.push({
            label: "Huertos",
            value: row[fieldName],
            order: 10,
            map: true,
          });
          break;
        case "agrobusiness":
          detail.push({
            label: "Agrícola",
            value: row[fieldName],
            order: 10,
            map: true,
          });
          break;
        case "birthDate":
          detail.push({
            label: "Edad",
            value: row[fieldName]
              ? getYearsFromBirth(dateConvertString(row[fieldName]))
              : "",
            order: 12,
            map: false,
          });
          break;

        default:
          break;
      }
    }
    return detail;
  };

  const showDetailTable = (moduleName) => {
    switch (moduleName) {
      case "Usuarios":
        return null;

      case "Proyectos":
        return (
          <DocumentsTableDetail
            dataDocs={detailModal.document}
            title="Proyecto"
          />
        );

      case "Tipo de Tag":
        return <TagsTableDetail dataDocs={detailModal.tag} title="Tags" />;

      case "Tipo de Protocolos":
        return (
          <DocumentsTableDetail
            dataDocs={detailModal.document}
            title="Tipo de Protocolos"
          />
        );

      case "Contratista":
        return (
          <DocumentsTableDetail
            dataDocs={detailModal.document}
            title="Contratista"
          />
        );

      case "Tipo de Actividad":
        return (
          <DocumentsTableDetail
            dataDocs={detailModal.document}
            title="Tipo de Actividad"
          />
        );

      case "Cuadrillas":
        return null;

      case "CheckLists":
        return (
          <QuestionsTableDetail
            dataQuestions={detailModal.questions}
            title="CheckLists"
          />
        );

      default:
        return null;
    }
  };

  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      className={classes.modal}
      open={openStateDetail}
      onClose={handleClose}
      closeAfterTransition
      // BackdropComponent={Backdrop}
      // BackdropProps={{
      // 	timeout: 500,
      // }}
    >
      {/* <Fade in={openStateDetail}> */}
      <div className={`${classes.paperModal} overflow-y-scroll`}>
        {/* <div className="relative">
          <BsContainer fluid>
            <div className="fixed right-30">
              <BsCol class="col-md-12 text-right pr-0">
                <Button onClick={handleClose}>
                  <CloseIcon />
                </Button>
              </BsCol>
            </div>
          </BsContainer>
        </div> */}
        <div className={classes.scrollAreaModalStyle}>
          <BsContainer fluid>
            <BsRow>
              <BsCol class="col-12">
                <table
                  className={clsx(
                    "table table-borderless table-sm",
                    classes.tableStyle
                  )}
                >
                  <thead>
                    <tr>
                      <th colSpan="2">
                        Detalles del usuario
                        {/*<i className="far fa-address-card"></i>*/}
                      </th>
                      <Button
                        onClick={handleClose}
                        className="sticky top-3 md:top-2"
                      >
                        <CloseIcon />
                      </Button>
                    </tr>
                  </thead>
                  <tbody className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mt-4">
                    {detailModal &&
                      handleRowTable(detailModal).map((item) => {
                        if (
                          item.map &&
                          (moduleName === "Usuarios" || moduleName === "Carga")
                        ) {
                          return (
                            <tr
                              key={item.label}
                              className={`${
                                item.label === "Agrícola" ||
                                item.label === "Huertos"
                                  ? "col-span-1 md:col-span-2 lg:col-span-3 flex flex-col "
                                  : ""
                              }`}
                            >
                              <td className={`!text-lg font-semibold`}>
                                {item.label}
                              </td>
                              <td className={classes.tdListStyle}>
                                {item.value && item.value.length > 0 ? (
                                  <ul className="flex flex-wrap gap-2">
                                    {item.value.map((ele, i) => (
                                      <li
                                        key={`${ele.id || ele.label}_${i}`}
                                        className="list-none"
                                      >
                                        <span
                                          style={{
                                            backgroundColor:
                                              theme.palette.grey[100],
                                            color: theme.palette.text.primary,
                                            border: `1px solid ${theme.palette.grey[300]}`,
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: 6,
                                            padding: "4px 12px",
                                            borderRadius: 20,
                                            fontSize: 13.5,
                                            fontWeight: 500,
                                            boxShadow:
                                              "0 1px 2px rgba(0,0,0,0.03)",
                                          }}
                                          title={ele?.label}
                                        >
                                          {/* Icono representativo según tipo */}
                                          {item.label === "Huertos" && (
                                            <i className="fas fa-seedling mr-1 text-green-600" />
                                          )}
                                          {item.label === "Agrícola" && (
                                            <i className="fas fa-tractor mr-1 text-yellow-700" />
                                          )}
                                          {ele?.label}
                                          {dashDelete(ele?.orchard)}
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span className="text-gray-400 italic">
                                    Sin datos
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        }

                        return (
                          <tr
                            key={item.label}
                            className="flex flex-col w-full "
                          >
                            <td
                              className={`${classes.labelTd} !text-lg first-letter:capitalize w-full`}
                            >
                              {item.label}
                            </td>
                            <td className="text-gray-700 ">
                              {item.value || (
                                <span className="text-gray-400 italic">-</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </BsCol>
              <BsCol class="col-md-12">{showDetailTable(moduleName)}</BsCol>
            </BsRow>
          </BsContainer>
        </div>
      </div>
      {/* </Fade> */}
    </Modal>
  );
};
export default ModalWidgetDetailTable;
